import React from "react";
import "../styles/Partners.css";

import b1 from "../assets/images/0part1.webp";
import b2 from "../assets/images/0part2.webp";
import b3 from "../assets/images/0part3.webp";
import b4 from "../assets/images/0part4.webp";
import b5 from "../assets/images/0part5.webp";
import b6 from "../assets/images/0part6.webp";
import b7 from "../assets/images/0part7.webp";

function Home() {
  const partners = [b1, b2, b3, b4, b5, b6, b7]; // 👈 yahan apni images ka array banayein

  return (
    <>
      {/* ✅ Pehle ka home content */}

      {/* -------- Our Trusted Partners Section -------- */}
      <section className="partners-section">
        <h2 className="partners-heading">Our Trusted Partners</h2>

        <div className="partners-scroll">
          <div className="partners-track">
            {/** 🔁 images ko 2 bar repeat kiya for seamless loop */}
            {[...partners, ...partners].map((src, i) => (
              <div className="partner-card" key={i}>
                <img src={src} alt={`partner-${i}`} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ✅ Baaki ka home content */}
    </>
  );
}

export default Home;
